import { useNavigate } from "react-router-dom";
import { useEmailVerification } from "../../../hooks/pages/emailVerification/useEmailVerification";

export default function VerifyEmail() {
  const navigate = useNavigate();
  const { status, message, verify } = useEmailVerification();

  return (
    <div className="max-w-md mx-auto mt-10 p-6 bg-white shadow rounded text-center">
      <h1 className="text-2xl font-semibold mb-4">Xác minh Email</h1>

      {status === "idle" && (
        <>
          <p className="text-gray-700 mb-4">
            Nhấn nút bên dưới để xác minh tài khoản của bạn.
          </p>
          <button
            onClick={verify}
            className="px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700 transition"
          >
            Xác minh ngay
          </button>
        </>
      )}

      {status === "loading" && (
        <p className="text-blue-600">Đang xác minh...</p>
      )}

      {status === "success" && (
        <>
          <p className="text-green-600 text-lg mb-4">{message}</p>
          <button
            onClick={() => navigate("/login")}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
          >
            Đến trang đăng nhập
          </button>
        </>
      )}

      {status === "error" && (
        <p className="text-red-600 text-lg">{message}</p>
      )}
    </div>
  );
}